import React from "react";
import { useCSVReader } from "react-papaparse";
import "./CsvImpoter.css";
import * as Icons from "heroicons-react";
import { Papa, usePapaParse } from "react-papaparse";

const styles = {
  csvReader: {
    display: "flex",
    flexDirection: "row",
    marginBottom: 10,
  },
  browseFile: {
    // width: '20%',
  },
  acceptedFile: {
    border: "1px solid #ccc",
    height: 45,
    lineHeight: 2.5,
    paddingLeft: 10,
    // width: '80%',
  },
  remove: {
    borderRadius: 0,
    // padding: '0 20px',
  },
  progressBarBackgroundColor: {
    backgroundColor: "black",
  },
};

const CsvPurchaseProduct = ({ setCsvData, handleImportButton, title }) => {
  // const { readString } = usePapaParse();
  const { CSVReader } = useCSVReader();

  return (
    <CSVReader
      onUploadAccepted={(results) => {
        const rows = (results.data || [])
          .filter((row) => {
            if (!row) return false;
            const code =
              row.article_code ||
              row.articleCode ||
              row["article code"] ||
              row["Article Code"];
            return code && String(code).trim() !== "";
          })
          .map((row) => {
            const code =
              row.article_code ||
              row.articleCode ||
              row["article code"] ||
              row["Article Code"];
            return {
              article_code: String(code).trim(),
              qty:
                row.qty !== undefined && row.qty !== ""
                  ? Number(row.qty)
                  : 1,
              order:
                row.order !== undefined && row.order !== ""
                  ? Number(row.order)
                  : undefined,
            };
          });
        setCsvData(rows);
      }}
      config={{ header: true }}
    >
      {({ getRootProps, acceptedFile, ProgressBar, getRemoveFileProps }) => (
        <>
          <div className="row">
            <div className="col-md-9">
              <div className="d-flex justify-content-between align-items-center mb-md-2">
                <label className="mb-0">Import Product</label>
                <a
                  href="/importSample/samplePurchaseImport.csv"
                  download="samplePurchaseImport.csv"
                  className="btn btn-outline-secondary btn-sm py-0 px-2 text-decoration-none"
                  style={{ fontSize: "12px" }}
                >
                  Download Sample CSV
                </a>
              </div>
              <div className="input-group mb-md-3">
                <span className="input-group-text" style={{ zIndex: 0 }}>
                  <button
                    type="button"
                    {...getRootProps()}
                    className=" btn btn-dark btn-block"
                  >
                    Browse Csv
                  </button>
                </span>
                <input
                  type="text"
                  className="form-control"
                  value={acceptedFile ? acceptedFile.name : "No File Selected"}
                  aria-describedby="basic-addon1"
                  id=""
                />
                <span className="input-group-text">
                  <span className="input-group-text" id="basic-addon1">
                    <button
                      {...getRemoveFileProps()}
                      className="btn btn-outline-dark btn-block z-0"
                      style={{ zIndex: 0 }}
                    >
                      <Icons.X size="16"></Icons.X>
                    </button>
                  </span>
                </span>
              </div>
            </div>
            <div className="col-md-3 mt-md-4">
              <button
                type="button"
                onClick={handleImportButton}
                className="btn btn-dark mt-2 col-12"
              >
                <Icons.CloudUploadOutline size="20" /> Import Product
              </button>
            </div>
            <div className="col-12">
              <ProgressBar />
            </div>
          </div>
        </>
      )}
    </CSVReader>
  );
};

export default CsvPurchaseProduct;
